import React, { useState, useRef, useEffect } from "react";
import {
  Dropdown,
  ButtonGroup,
  FormControl,
  Badge,
  CloseButton,
  Tooltip,
} from "react-bootstrap";
import { FaCheck } from "react-icons/fa";
import TooltipTextComponent from "../TooltipTextComponent";

const MultiSelectDropdown = ({
  name,
  title,
  selected = [],
  options = [],
  formData,
  setFormData,
  pathwayToFetchSubKeyData,
  disabled = false,
  placeholder,
}) => {
  const [searchText, setSearchText] = useState("");
  const [menuOpen, setMenuOpen] = useState(false); // Track dropdown state
  const searchInputRef = useRef(null); // Ref for the search input
  const maxVisible = 1;

  let last_id = selected[selected.length - 1];
  const selectedData = options.filter((opt) => selected.includes(opt.value));
  const selectedOptions = options.filter((opt) => last_id === opt.value);
  const visibleSelections = selectedOptions
    .slice(-maxVisible)
    .map((opt) => opt.label);
  const extraCount = selected.length - maxVisible;

  const buttonLabel = visibleSelections.join(", ") ? (
    <div
      className={`selected__one${
        extraCount > 0
          ? " selected__multi d-flex align-items-center justify-content-between"
          : ""
      } w-100`}
      title={visibleSelections}
    >
      <span className="selected__otext w-100 text-start ellipsisL1">
        {visibleSelections.join(", ")}
      </span>
      {extraCount > 0 && (
        <Badge className="selected__oicn d-flex align-items-center justify-content-center bg-white rounded-pill border text-dark top-0">
          <span className="fw-500">+</span>
          <span className="fw-500">{extraCount}</span>
        </Badge>
      )}
    </div>
  ) : (
    ""
  );

  const toggleOption = (option) => {
    let newArray = selected.includes(option.value)
      ? selected.filter((v) => v !== option.value)
      : [...selected, option.value];
    var name_append = name + "_name";
    let selectedlabel = options.filter((opt) => newArray.includes(opt.value));
    setFormData({
      ...formData,
      [name]: newArray,
      [name_append]: selectedlabel,
    });
    setSearchText("");
    pathwayToFetchSubKeyData &&
      pathwayToFetchSubKeyData(name, newArray, selectedlabel);
  };

  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(searchText.toLowerCase())
  );
  const allStatus = formData?.[name]?.length === filteredOptions?.length;
  const selectAllOption = () => {
    var newArray = [];
    var selectedlabel = [];
    if (!allStatus) {
      filteredOptions?.map((item, i) => {
        newArray = [...newArray, item.value];
        selectedlabel = [...selectedlabel, item];
      });
    }
    var name_append = name + "_name";
    setFormData({
      ...formData,
      [name]: newArray,
      [name_append]: selectedlabel,
    });
    setSearchText("");
    pathwayToFetchSubKeyData &&
      pathwayToFetchSubKeyData(name, newArray, selectedlabel);
  };

  useEffect(() => {
    if (menuOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [menuOpen]);

  return (
    <Dropdown
      as={ButtonGroup}
      disabled={disabled}
      className={`dropdown__one${extraCount > 0 ? " dropdown__multi" : ""}`}
      onToggle={(isOpen) => setMenuOpen(isOpen)}
      autoClose="outside"
    >
      <Dropdown.Toggle
        title={title}
        variant="light"
        id={`dropdown-custom-${name}`}
        className={disabled ? "disabled" : ""}
      >
        {buttonLabel || placeholder || "Please select"}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {selectedData?.length > 0 && (
          <div className="selected__list d-flex flex-wrap align-items-start">
            {selectedData.map((sItem, idx) => (
              <Badge
                key={idx}
                pill
                className="selected__items d-flex align-items-center text-gray fw-500"
              >
                <span className="text-gray">{sItem.label}</span>
                <CloseButton
                  title="Remove"
                  className="ms-1 p-0"
                  onClick={() => toggleOption(sItem)}
                />
              </Badge>
            ))}
          </div>
        )}
        <div className="drop__search">
          <FormControl
            ref={searchInputRef}
            placeholder="Search here..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <div
          class="drop__selectall d-flex align-items-center justify-content-end cursor-pointer"
          onClick={selectAllOption}
          title="Click to select all"
        >
          <span className="fw-normal text-gray">Select all</span>
          {allStatus ? (
            <FaCheck
              className="text-success ms-2"
              style={{ width: "12px", height: "12px" }}
            />
          ) : (
            ""
          )}
        </div>
        <div className="drop__bottom">
          {filteredOptions.length === 0 && (
            <Dropdown.Item disabled className="text-center d-block">
              <p>No matches</p>
            </Dropdown.Item>
          )}
          {filteredOptions.map((option) => (
            <Dropdown.Item
              key={option.value}
              active={selected.includes(option.value)}
              onClick={(e) => {
                e.preventDefault(); // 👈 prevent menu from closing
                toggleOption(option);
              }}
              name={name}
              title={option.label}
            >
              <span>{option.label}</span>
              {selected.includes(option.value) && (
                <FaCheck
                  className="text-success ms-2"
                  style={{ width: "12px", height: "12px" }}
                />
              )}
            </Dropdown.Item>
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MultiSelectDropdown;
